<template>
  <div>
    <SnackbarComponent v-model="snackbar.show" :message="snackbar.message" :color="snackbar.color" />
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="text-h5 pa-4">Create Lab</v-card-title>
        <v-divider></v-divider>

        <v-card-text class="pa-6">
          <v-form ref="form" v-model="valid">
            <v-text-field v-model="formData.lab_name" label="Lab Name*" variant="outlined" density="compact"
              :rules="[(v) => !!v || 'Lab Name is required']" />
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" variant="text" @click="handleClose" :disabled="loading">
            Cancel
          </v-btn>
          <v-btn color="primary" variant="flat" :disabled="!valid || loading" :loading="loading" @click="handleSubmit">
            Create
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SnackbarComponent from "@/components/Extras/Snackbar.vue";
import { create_lab_masters } from "@/graphql/mutations";
import { generateClient } from "aws-amplify/api";
const client = generateClient();

export default {
  name: "CreateLab",
  components: {
    SnackbarComponent,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue", "created"],
  data() {
    return {
      valid: false,
      loading: false,
      formData: {
        lab_name: "",
      },
      snackbar: {
        show: false,
        message: "",
        color: "success",
      },
    };
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    modelValue(newVal) {
      if (!newVal) {
        this.resetForm();
      }
    },
  },
  methods: {
    async handleSubmit() {
      const { valid } = await this.$refs.form.validate();
      if (!valid) {
        return;
      }

      this.loading = true;

      try {
        const input = {
          lab_name: this.formData.lab_name,
          source: "BMS",
        };

        const response = await client.graphql({
          query: create_lab_masters,
          variables: {
            input: input,
          },
        });

        const responseData = JSON.parse(
          response.data.create_lab_masters
        );

        if (responseData.status == "SUCCESS") {
          this.loading = false;
          this.snackbar = {
            show: true,
            message:
              responseData.status_message ||
              "Medication class created successfully",
            color: "success",
          };
          this.$emit("created", 0);
          this.handleClose();
        } else {
          this.loading = false;
          this.snackbar = {
            show: true,
            message:
              responseData.status_message ||
              "Failed to create medication class",
            color: "error",
          };
        }
      } catch (error) {
        this.loading = false;
        console.error("Error creating medication class:", error);
        this.snackbar = {
          show: true,
          message:
            error.message ||
            "An error occurred while creating the medication class",
          color: "error",
        };
      }
    },
    handleClose() {
      this.dialog = false;
      this.resetForm();
    },
    resetForm() {
      this.formData = {
        lab_name: "",
      };
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
  },
};
</script>
